// 시가총액 한국 화폐 단위 포맷 (조 / 억 / 원).
// 입력은 원(KRW) 단위 정수. 음수/0/null 은 '—' 로 반환.
//
// 표기 규칙:
//   ≥ 1조  → "12.3조"  (소수점 1자리)
//   ≥ 1억  → "1,234억" (정수)
//   그 외   → "123,456원"
export function formatMarketCapKrw(value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(value) || value <= 0) {
    return '—';
  }
  const JO = 1_0000_0000_0000; // 1조 = 10^12
  const EOK = 1_0000_0000;     // 1억 = 10^8
  if (value >= JO) {
    const v = value / JO;
    return `${v.toFixed(1).replace(/\.0$/, '')}조`;
  }
  if (value >= EOK) {
    const v = Math.round(value / EOK);
    return `${v.toLocaleString('ko-KR')}억`;
  }
  return `${value.toLocaleString('ko-KR')}원`;
}

// 스톡 스코어 표기 (소수점 2자리, null → '—').
export function formatScore(value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return '—';
  return value.toFixed(2);
}

// 원천 종류(source) 사용자 친화 라벨 매핑.
// 백엔드가 어떤 enum 값을 내려도 안전하도록, 매칭 실패 시 대문자 변환만 적용.
const SOURCE_LABEL: Record<string, string> = {
  naver_primary: 'PRIMARY',
  naver_secondary: 'SECONDARY',
  naver_theme: 'THEME',
  naver_upjong: 'UPJONG',
  primary: 'PRIMARY',
  secondary: 'SECONDARY',
  theme: 'THEME',
};

export function formatSourceLabel(source: string): string {
  if (!source) return '—';
  return SOURCE_LABEL[source] ?? source.toUpperCase();
}
